// extracted by mini-css-extract-plugin
module.exports = {"DialogRow":"Dialog_DialogRow__3SIjB","DialogMain":"Dialog_DialogMain__2O2dV","Mb":"Dialog_Mb__3ujJM"};